"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiSchema = _interopRequireDefault(require("../module/uiSchema"));

var _uiPreview = _interopRequireDefault(require("../../condition/uiPreview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = {
  "ui:field": "primusChildren",
  "ui:layout": "section",
  "ui:collapsible": true,
  "ui:documentType": "condition",
  "ui:title": "Tilstandsvurderinger",
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData
    }) {
      return {
        "description": formData.length
      };
    }

  },
  "ui:buttonProps": {
    "variant": "contained",
    "color": "primary"
  },
  "ui:buttons": [{
    "icon": "add",
    "label": "Ny tilstandsvurdering",
    "documentType": "condition",
    "uniqueId": "<new>"
  }],
  "items": _extends({}, _uiSchema.default, {
    "ui:preview": _uiPreview.default
  })
};
exports.default = _default;
module.exports = exports.default;